import React from 'react';
import { styled } from '@mui/material';
import { Colors } from 'library';
import { Checkbox } from './Checkbox';

interface CheckboxRowProps {
    checked: boolean;
    onChange: (checked: boolean) => void;
    label: string;
    subtitle?: string;
}

export function CheckboxRow({ checked, onChange, label, subtitle }: CheckboxRowProps) {
    return (
        <Row>
            <Checkbox checked={checked} onChange={onChange} />
            <LabelGroup>
                <Label>{label}</Label>
                {subtitle && <Subtitle>{subtitle}</Subtitle>}
            </LabelGroup>
        </Row>
    );
}

const Row = styled('label')({
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    padding: '10px 16px',
    borderRadius: 8,
    border: `1px solid ${Colors.lightGrey}`,
    backgroundColor: Colors.faintGrey,
    cursor: 'pointer',
    '&:hover': {
        borderColor: Colors.mediumGrey,
    },
});

const LabelGroup = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
});

const Label = styled('span')({
    fontSize: 14,
    fontWeight: 500,
    color: Colors.darkNavy,
});

const Subtitle = styled('span')({
    fontSize: 12,
    color: Colors.mediumGrey,
});
